import React from 'react';

import Link from './Link';
import {resizeContentfulImage} from '../util';

const AuthorCard = ({author, className, minimal = false}) => (
  <div className={className}>
    {author.link ? (
      <Link href={author.link}>
        <AuthorCardContent author={author} minimal={minimal} />
      </Link>
    ) : (
      <AuthorCardContent author={author} minimal={minimal} />
    )}
  </div>
);

const AuthorCardContent = ({author, minimal}) => (
  minimal ? (
    <div className="flex items-center gap-2 border border-gray-200 rounded-lg px-6 py-4 bg-gray-50">
      {author.image && (
        <img
          className="h-5 w-5 rounded-full object-cover"
          src={resizeContentfulImage(author.image, 200, 200)}
          alt={author.name}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
      <span className="text-sm text-gray-500">
        Written by
        {' '}
        <span className="text-gray-800 font-medium">{author.name}</span>
        {author.title && (
          <>
            ,
            {' '}
            {author.title}
          </>
        )}
      </span>
    </div>
  ) : (
    <div className="flex border rounded-lg p-4 bg-gray-50 border-gray-200">
      {author.image && (
        <img
          className="h-12 w-12 rounded-full object-cover mr-4"
          src={resizeContentfulImage(author.image, 200, 200)}
          alt={author.name}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
      <div className="flex flex-col">
        <span className="text-base font-medium whitespace-nowrap text-gray-500">
          Written by
          {' '}
          <span className="text-gray-800">
            {author.name}
          </span>
        </span>
        {author.title && (
          <span className="text-sm font-normal text-gray-500">
            {author.title}
          </span>
        )}
      </div>
    </div>
  )
);

export default AuthorCard;
